import { refusalNotice, toRefusal } from "@perksmith/api-client";

/**
 * Whether the edge is holding the app for planned maintenance, as far as this till has heard.
 *
 * The till never shows a full-screen block: a sale in progress must not be taken away. It only
 * remembers that the last answer was the maintenance hold so a quiet banner can say so; every
 * call keeps going through the till's own offline handling.
 */
let held = false;
const listeners = new Set<() => void>();

function set(next: boolean): void {
  if (held === next) return;
  held = next;
  listeners.forEach((listener) => listener());
}

export const isMaintenanceHeld = (): boolean => held;

export function subscribeMaintenanceHeld(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Notes what one answer says: the hold when it is the edge's maintenance 503, and "open again" for any other answer. */
export function noteAnswer(response: Pick<Response, "status" | "headers">, body: unknown): void {
  set(response.status === 503 && refusalNotice(toRefusal(response, body)) !== undefined);
}

/** For tests: forget everything heard. */
export function resetMaintenanceHeld(): void {
  held = false;
  listeners.clear();
}
